import { L10n, setCulture } from '@syncfusion/ej2-base';

// Deutsche Lokalisierung für Syncfusion Document Editor
const deLocale = {
  'de': {
    'documenteditor': {
      'Table': 'Tabelle',
      'Row': 'Zeile',
      'Cell': 'Zelle',
      'Ok': 'OK',
      'Cancel': 'Abbrechen',
      'Size': 'Größe',
      'Preferred Width': 'Bevorzugte Breite',
      'Points': 'Punkte',
      'Percent': 'Prozent',
      'Measure in': 'Einheit',
      'Alignment': 'Ausrichtung',
      'Left': 'Links',
      'Center': 'Zentriert',
      'Right': 'Rechts',
      'Justify': 'Blocksatz',
      'Indent from left': 'Einzug von links',
      'Borders and Shading': 'Rahmen und Schattierung',
      'Options': 'Optionen',
      'Specify height': 'Höhe angeben',
      'At least': 'Mindestens',
      'Exactly': 'Genau',
      'Row height is': 'Zeilenhöhe ist',
      'Allow row to break across pages': 'Zeilenumbruch über Seiten erlauben',
      'Repeat as header row at the top of each page': 'Als Kopfzeile auf jeder Seite wiederholen',
      'Vertical alignment': 'Vertikale Ausrichtung',
      'Top': 'Oben',
      'Bottom': 'Unten',
      'Default cell margins': 'Standard-Zellenränder',
      'Default cell spacing': 'Standard-Zellabstand',
      'Allow spacing between cells': 'Abstand zwischen Zellen erlauben',
      'Cell margins': 'Zellenränder',
      'Same as the whole table': 'Wie gesamte Tabelle',
      'Borders': 'Rahmen',
      'None': 'Keine',
      'Style': 'Stil',
      'Width': 'Breite',
      'Height': 'Höhe',
      'Letter': 'Brief',
      'Tabloid': 'Tabloid',
      'Legal': 'Legal',
      'Statement': 'Statement',
      'Executive': 'Executive',
      'A3': 'A3',
      'A4': 'A4',
      'A5': 'A5',
      'B4': 'B4',
      'B5': 'B5',
      'Custom Size': 'Benutzerdefinierte Größe',
      'Different odd and even': 'Unterschiedlich für gerade und ungerade',
      'Different first page': 'Unterschiedliche erste Seite',
      'From edge': 'Vom Rand',
      'Header': 'Kopfzeile',
      'Footer': 'Fußzeile',
      'Margin': 'Seitenränder',
      'Paper': 'Papier',
      'Layout': 'Layout',
      'Orientation': 'Ausrichtung',
      'Landscape': 'Querformat',
      'Portrait': 'Hochformat',
      'Show page numbers': 'Seitenzahlen anzeigen',
      'Right align page numbers': 'Seitenzahlen rechtsbündig',
      'Nothing': 'Nichts',
      'Tab leader': 'Füllzeichen',
      'Show levels': 'Ebenen anzeigen',
      'Use hyperlinks instead of page numbers': 'Hyperlinks statt Seitenzahlen verwenden',
      'Build table of contents from': 'Inhaltsverzeichnis erstellen aus',
      'Styles': 'Formatvorlagen',
      'Available styles': 'Verfügbare Formatvorlagen',
      'TOC level': 'IVZ-Ebene',
      'Heading': 'Überschrift',
      'Heading 1': 'Überschrift 1',
      'Heading 2': 'Überschrift 2',
      'Heading 3': 'Überschrift 3',
      'Heading 4': 'Überschrift 4',
      'Heading 5': 'Überschrift 5',
      'Heading 6': 'Überschrift 6',
      'List Paragraph': 'Listenabsatz',
      'Normal': 'Standard',
      'Outline levels': 'Gliederungsebenen',
      'Table entry fields': 'Tabelleneintrag-Felder',
      'Modify': 'Ändern',
      'Color': 'Farbe',
      'Setting': 'Einstellung',
      'Box': 'Box',
      'All': 'Alle',
      'Custom': 'Benutzerdefiniert',
      'Preview': 'Vorschau',
      'Shading': 'Schattierung',
      'Fill': 'Füllung',
      'Apply To': 'Anwenden auf',
      'Table Properties': 'Tabelleneigenschaften',
      'Cell Options': 'Zellenoptionen',
      'Table Options': 'Tabellenoptionen',
      'Insert Table': 'Tabelle einfügen',
      'Number of columns': 'Anzahl Spalten',
      'Number of rows': 'Anzahl Zeilen',
      'Text to display': 'Anzuzeigender Text',
      'Address': 'Adresse',
      'Insert Hyperlink': 'Hyperlink einfügen',
      'Edit Hyperlink': 'Hyperlink bearbeiten',
      'Insert': 'Einfügen',
      'General': 'Allgemein',
      'Indentation': 'Einzug',
      'Before text': 'Vor Text',
      'After text': 'Nach Text',
      'Special': 'Sondereinzug',
      'First line': 'Erste Zeile',
      'Hanging': 'Hängend',
      'After': 'Nach',
      'Before': 'Vor',
      'Line Spacing': 'Zeilenabstand',
      'At': 'Bei',
      'Multiple': 'Mehrfach',
      'Spacing': 'Abstand',
      'Define new Multilevel list': 'Neue mehrstufige Liste definieren',
      'List level': 'Listenebene',
      'Choose level to modify': 'Zu ändernde Ebene wählen',
      'Level': 'Ebene',
      'Number format': 'Zahlenformat',
      'Number style for this level': 'Zahlenformat für diese Ebene',
      'Enter formatting for number': 'Format für Nummer eingeben',
      'Start at': 'Beginnen bei',
      'Restart list after': 'Liste neu beginnen nach',
      'Position': 'Position',
      'Text indent at': 'Texteinzug bei',
      'Aligned at': 'Ausgerichtet bei',
      'Follow number with': 'Nummer gefolgt von',
      'Tab character': 'Tabulator',
      'Space': 'Leerzeichen',
      'Arabic': 'Arabisch',
      'UpRoman': 'Römisch groß',
      'LowRoman': 'Römisch klein',
      'UpLetter': 'Buchstaben groß',
      'LowLetter': 'Buchstaben klein',
      'Number': 'Nummer',
      'Leading zero': 'Mit führender Null',
      'Bullet': 'Aufzählungszeichen',
      'Ordinal': 'Ordinal',
      'Ordinal Text': 'Ordinal Text',
      'For East': 'Für Ost',
      'No Restart': 'Kein Neustart',
      'Font': 'Schriftart',
      'Font style': 'Schriftschnitt',
      'Underline style': 'Unterstreichungsstil',
      'Font color': 'Schriftfarbe',
      'Effects': 'Effekte',
      'Strikethrough': 'Durchgestrichen',
      'Superscript': 'Hochgestellt',
      'Subscript': 'Tiefgestellt',
      'Double strikethrough': 'Doppelt durchgestrichen',
      'Regular': 'Normal',
      'Bold': 'Fett',
      'Italic': 'Kursiv',
      'Cut': 'Ausschneiden',
      'Copy': 'Kopieren',
      'Paste': 'Einfügen',
      'Hyperlink': 'Hyperlink',
      'Open Hyperlink': 'Hyperlink öffnen',
      'Copy Hyperlink': 'Hyperlink kopieren',
      'Remove Hyperlink': 'Hyperlink entfernen',
      'Paragraph': 'Absatz',
      'Linked Style': 'Verknüpfte Formatvorlage',
      'Character': 'Zeichen',
      'Merge Cells': 'Zellen verbinden',
      'Insert Above': 'Zeile oberhalb einfügen',
      'Insert Below': 'Zeile unterhalb einfügen',
      'Insert Left': 'Spalte links einfügen',
      'Insert Right': 'Spalte rechts einfügen',
      'Delete': 'Löschen',
      'Delete Table': 'Tabelle löschen',
      'Delete Row': 'Zeile löschen',
      'Delete Column': 'Spalte löschen',
      'File Name': 'Dateiname',
      'Format Type': 'Formattyp',
      'Save': 'Speichern',
      'Navigation': 'Navigation',
      'Results': 'Ergebnisse',
      'Replace': 'Ersetzen',
      'Replace All': 'Alle ersetzen',
      'We replaced all': 'Alle ersetzt:',
      'Find': 'Suchen',
      'No matches': 'Keine Treffer',
      'All Done': 'Fertig',
      'Result': 'Ergebnis',
      'of': 'von',
      'instances': 'Instanzen',
      'with': 'mit',
      'Click to follow link': 'Zum Öffnen des Links klicken',
      'Continue Numbering': 'Nummerierung fortsetzen',
      'Bookmark name': 'Lesezeichenname',
      'Close': 'Schließen',
      'Restart At': 'Neustart bei',
      'Properties': 'Eigenschaften',
      'Name': 'Name',
      'Style type': 'Formatvorlage-Typ',
      'Style based on': 'Basiert auf Formatvorlage',
      'Style for following paragraph': 'Formatvorlage für folgenden Absatz',
      'Formatting': 'Formatierung',
      'Numbering and Bullets': 'Nummerierung und Aufzählungszeichen',
      'Numbering': 'Nummerierung',
      'Update Field': 'Feld aktualisieren',
      'Edit Field': 'Feld bearbeiten',
      'Bookmark': 'Lesezeichen',
      'Page Setup': 'Seite einrichten',
      'No bookmarks found': 'Keine Lesezeichen gefunden',
      'Number of heading or outline levels to be shown in table of contents': 'Anzahl der Überschriften- oder Gliederungsebenen im Inhaltsverzeichnis',
      'Show page numbers in table of contents': 'Seitenzahlen im Inhaltsverzeichnis anzeigen',
      'Right align page numbers in table of contents': 'Seitenzahlen im Inhaltsverzeichnis rechtsbündig',
      'Use hyperlinks': 'Hyperlinks verwenden',
      'page': 'Seite',
      'pages': 'Seiten',
      'word': 'Wort',
      'words': 'Wörter',
      'character': 'Zeichen',
      'characters': 'Zeichen',
      'line': 'Zeile',
      'lines': 'Zeilen',
      'spell': 'Rechtschreibung',
      'spellcheck': 'Rechtschreibprüfung',
      'No Suggestions': 'Keine Vorschläge',
      'Add to Dictionary': 'Zum Wörterbuch hinzufügen',
      'Ignore': 'Ignorieren',
      'Ignore All': 'Alle ignorieren',
      'Spelling': 'Rechtschreibung',
      'Spelling & Grammar': 'Rechtschreibung & Grammatik',
      'Change': 'Ändern',
      'Change All': 'Alle ändern',
      'The spelling and grammar check is complete': 'Rechtschreibprüfung abgeschlossen',
      'Suggestions': 'Vorschläge',
      'Not in Dictionary': 'Nicht im Wörterbuch'
    },
    'documenteditorcontainer': {
      'New': 'Neu',
      'Open': 'Öffnen',
      'Undo': 'Rückgängig',
      'Redo': 'Wiederholen',
      'Image': 'Bild',
      'Table': 'Tabelle',
      'Link': 'Hyperlink',
      'Bookmark': 'Lesezeichen',
      'Table of Contents': 'Inhaltsverzeichnis',
      'HEADING - Loss less Export': 'ÜBERSCHRIFT - Verlustfreier Export',
      'Header': 'Kopfzeile',
      'Footer': 'Fußzeile',
      'Page Setup': 'Seite einrichten',
      'Page Number': 'Seitenzahl',
      'Break': 'Umbruch',
      'Find': 'Suchen',
      'Local Clipboard': 'Lokale Zwischenablage',
      'Restrict Editing': 'Bearbeitung einschränken',
      'Upload from computer': 'Von Computer hochladen',
      'By URL': 'Per URL',
      'Page Break': 'Seitenumbruch',
      'Section Break': 'Abschnittsumbruch',
      'Header And Footer': 'Kopf- und Fußzeile',
      'Options': 'Optionen',
      'Levels': 'Ebenen',
      'Different First Page': 'Unterschiedliche erste Seite',
      'Different header and footer for odd and even pages': 'Unterschiedliche Kopf- und Fußzeilen für gerade und ungerade Seiten',
      'Different Odd And Even Pages': 'Unterschiedliche gerade und ungerade Seiten',
      'Different header and footer for first page': 'Unterschiedliche Kopf- und Fußzeile für erste Seite',
      'Position': 'Position',
      'Header from Top': 'Kopfzeile von oben',
      'Footer from Bottom': 'Fußzeile von unten',
      'Distance from top of the page to top of the header': 'Abstand vom oberen Seitenrand zur Kopfzeile',
      'Distance from bottom of the page to bottom of the footer': 'Abstand vom unteren Seitenrand zur Fußzeile',
      'Aspect ratio': 'Seitenverhältnis',
      'W': 'B',
      'H': 'H',
      'Width': 'Breite',
      'Height': 'Höhe',
      'Text': 'Text',
      'Paragraph': 'Absatz',
      'Fill': 'Füllung',
      'Fill color': 'Füllfarbe',
      'Border Style': 'Rahmenstil',
      'Outside borders': 'Außenrahmen',
      'All borders': 'Alle Rahmen',
      'Inside borders': 'Innenrahmen',
      'Left border': 'Linker Rahmen',
      'Inside vertical border': 'Innerer vertikaler Rahmen',
      'Right border': 'Rechter Rahmen',
      'Top border': 'Oberer Rahmen',
      'Inside horizontal border': 'Innerer horizontaler Rahmen',
      'Bottom border': 'Unterer Rahmen',
      'Border color': 'Rahmenfarbe',
      'Border width': 'Rahmenbreite',
      'Cell': 'Zelle',
      'Merge cells': 'Zellen verbinden',
      'Insert Or Delete': 'Einfügen oder Löschen',
      'Insert columns to the left': 'Spalten links einfügen',
      'Insert columns to the right': 'Spalten rechts einfügen',
      'Insert rows above': 'Zeilen oberhalb einfügen',
      'Insert rows below': 'Zeilen unterhalb einfügen',
      'Delete rows': 'Zeilen löschen',
      'Delete columns': 'Spalten löschen',
      'Cell Margin': 'Zellenrand',
      'Top': 'Oben',
      'Bottom': 'Unten',
      'Left': 'Links',
      'Right': 'Rechts',
      'Align Text': 'Text ausrichten',
      'Align top': 'Oben ausrichten',
      'Align bottom': 'Unten ausrichten',
      'Align center': 'Zentriert ausrichten',
      'Number of heading or outline levels to be shown in table of contents': 'Anzahl der Überschriften- oder Gliederungsebenen im Inhaltsverzeichnis',
      'Show page numbers': 'Seitenzahlen anzeigen',
      'Show page numbers in table of contents': 'Seitenzahlen im Inhaltsverzeichnis anzeigen',
      'Right align page numbers': 'Seitenzahlen rechtsbündig',
      'Right align page numbers in table of contents': 'Seitenzahlen im Inhaltsverzeichnis rechtsbündig',
      'Use hyperlinks': 'Hyperlinks verwenden',
      'Use hyperlinks instead of page numbers': 'Hyperlinks statt Seitenzahlen verwenden',
      'Font': 'Schriftart',
      'Font Size': 'Schriftgröße',
      'Font Color': 'Schriftfarbe',
      'Text Highlight Color': 'Textmarkierungsfarbe',
      'Clear All Formatting': 'Alle Formatierungen löschen',
      'Bold Tooltip': 'Fett (Strg+B)',
      'Italic Tooltip': 'Kursiv (Strg+I)',
      'Underline Tooltip': 'Unterstrichen (Strg+U)',
      'Strikethrough': 'Durchgestrichen',
      'Superscript Tooltip': 'Hochgestellt (Strg+Umschalt++)',
      'Subscript Tooltip': 'Tiefgestellt (Strg+=)',
      'Align left Tooltip': 'Linksbündig (Strg+L)',
      'Center Tooltip': 'Zentriert (Strg+E)',
      'Align right Tooltip': 'Rechtsbündig (Strg+R)',
      'Justify Tooltip': 'Blocksatz (Strg+J)',
      'Decrease indent': 'Einzug verkleinern',
      'Increase indent': 'Einzug vergrößern',
      'Line spacing': 'Zeilenabstand',
      'Bullets': 'Aufzählungszeichen',
      'Numbering': 'Nummerierung',
      'Styles': 'Formatvorlagen',
      'Manage Styles': 'Formatvorlagen verwalten',
      'Page': 'Seite',
      'of': 'von',
      'Fit one page': 'Eine Seite anpassen',
      'Spell Check': 'Rechtschreibprüfung',
      'Underline errors': 'Fehler unterstreichen',
      'Fit page width': 'Seitenbreite anpassen',
      'Update': 'Aktualisieren',
      'Cancel': 'Abbrechen',
      'Insert': 'Einfügen',
      'No Style': 'Keine Formatvorlage',
      'Create a style': 'Formatvorlage erstellen',
      'Update heading1 to match current selection?': 'Überschrift 1 an aktuelle Auswahl anpassen?',
      'Update heading2 to match current selection?': 'Überschrift 2 an aktuelle Auswahl anpassen?',
      'Update heading3 to match current selection?': 'Überschrift 3 an aktuelle Auswahl anpassen?',
      'Update heading4 to match current selection?': 'Überschrift 4 an aktuelle Auswahl anpassen?',
      'Update heading5 to match current selection?': 'Überschrift 5 an aktuelle Auswahl anpassen?',
      'Update heading6 to match current selection?': 'Überschrift 6 an aktuelle Auswahl anpassen?',
      'Expand all': 'Alle erweitern',
      'Collapse all': 'Alle reduzieren',
      'Find and Replace': 'Suchen und Ersetzen',
      'Comments': 'Kommentare',
      'Track Changes': 'Änderungen nachverfolgen',
      'TableOfContents': 'Inhaltsverzeichnis',
      'Footnote': 'Fußnote',
      'Endnote': 'Endnote',
      'FormFields': 'Formularfelder',
      'Protect Document': 'Dokument schützen',
      'Download': 'Herunterladen',
      'Print': 'Drucken',
      'File': 'Datei',
      'Edit': 'Bearbeiten',
      'View': 'Ansicht',
      'Home': 'Start',
      'References': 'Referenzen'
    },
    'pdfviewer': {
      'PdfViewer': 'PDF Viewer',
      'Cancel': 'Abbrechen',
      'Download file': 'Datei herunterladen',
      'Download': 'Herunterladen',
      'Enter Password': 'Passwort eingeben',
      'File Corrupted': 'Datei beschädigt',
      'File Corrupted Content': 'Die Datei ist beschädigt und kann nicht geöffnet werden.',
      'Fit Page': 'Ganze Seite',
      'Fit Width': 'Seitenbreite',
      'Automatic': 'Automatisch',
      'Go To First Page': 'Erste Seite',
      'Invalid Password': 'Ungültiges Passwort',
      'Next Page': 'Nächste Seite',
      'OK': 'OK',
      'Open': 'Öffnen',
      'Page Number': 'Seitenzahl',
      'Previous Page': 'Vorherige Seite',
      'Go To Last Page': 'Letzte Seite',
      'Zoom': 'Zoom',
      'Zoom In': 'Vergrößern',
      'Zoom Out': 'Verkleinern',
      'Page Thumbnails': 'Seitenvorschau',
      'Bookmarks': 'Lesezeichen',
      'Print': 'Drucken',
      'Password Protected': 'Passwortgeschützt',
      'Copy': 'Kopieren',
      'Text Selection': 'Textauswahl',
      'Panning': 'Verschieben',
      'Text Search': 'Textsuche',
      'Find in document': 'Im Dokument suchen',
      'Match case': 'Groß-/Kleinschreibung',
      'Apply': 'Anwenden',
      'GoToPage': 'Gehe zu Seite',
      'No matches': 'Keine Treffer',
      'No Text Found': 'Kein Text gefunden',
      'Undo': 'Rückgängig',
      'Redo': 'Wiederholen',
      'Annotation': 'Anmerkung',
      'Highlight': 'Hervorheben',
      'Underline': 'Unterstreichen',
      'Strikethrough': 'Durchstreichen',
      'Delete': 'Löschen',
      'Opacity': 'Deckkraft',
      'Color edit': 'Farbe bearbeiten',
      'Opacity edit': 'Deckkraft bearbeiten',
      'Highlight context': 'Hervorheben',
      'Underline context': 'Unterstreichen',
      'Strikethrough context': 'Durchstreichen',
      'Server error': 'Server-Fehler',
      'Client error': 'Client-Fehler',
      'Open text': 'Öffnen',
      'First text': 'Erste',
      'Previous text': 'Vorherige',
      'Next text': 'Nächste',
      'Last text': 'Letzte',
      'Zoom in text': 'Vergrößern',
      'Zoom out text': 'Verkleinern',
      'Selection text': 'Auswahl',
      'Pan text': 'Verschieben',
      'Print text': 'Drucken',
      'Search text': 'Suchen',
      'Annotation Edit text': 'Anmerkung bearbeiten',
      'Line Thickness': 'Linienstärke',
      'Line Properties': 'Linieneigenschaften',
      'Start Arrow': 'Startpfeil',
      'End Arrow': 'Endpfeil',
      'Line Style': 'Linienstil',
      'Fill Color': 'Füllfarbe',
      'Line Color': 'Linienfarbe',
      'None': 'Keine',
      'Open Arrow': 'Offener Pfeil',
      'Closed Arrow': 'Geschlossener Pfeil',
      'Round Arrow': 'Runder Pfeil',
      'Square Arrow': 'Quadratischer Pfeil',
      'Diamond Arrow': 'Diamant-Pfeil',
      'Butt': 'Stumpf',
      'Cut': 'Ausschneiden',
      'Paste': 'Einfügen',
      'Delete Context': 'Löschen',
      'Properties': 'Eigenschaften',
      'Add Stamp': 'Stempel hinzufügen',
      'Add Shapes': 'Formen hinzufügen',
      'Stroke edit': 'Kontur bearbeiten',
      'Change thickness': 'Stärke ändern',
      'Add line': 'Linie hinzufügen',
      'Add arrow': 'Pfeil hinzufügen',
      'Add rectangle': 'Rechteck hinzufügen',
      'Add circle': 'Kreis hinzufügen',
      'Add polygon': 'Polygon hinzufügen',
      'Add Comments': 'Kommentare hinzufügen',
      'Comments': 'Kommentare',
      'No Comments Yet': 'Noch keine Kommentare',
      'Accepted': 'Akzeptiert',
      'Completed': 'Abgeschlossen',
      'Cancelled': 'Abgebrochen',
      'Rejected': 'Abgelehnt',
      'Leader Length': 'Führungslinienlänge',
      'Scale Ratio': 'Maßstab',
      'Calibrate': 'Kalibrieren',
      'Calibrate Distance': 'Entfernung kalibrieren',
      'Calibrate Perimeter': 'Umfang kalibrieren',
      'Calibrate Area': 'Fläche kalibrieren',
      'Calibrate Radius': 'Radius kalibrieren',
      'Calibrate Volume': 'Volumen kalibrieren',
      'Depth': 'Tiefe',
      'Closed': 'Geschlossen',
      'Round': 'Rund',
      'Square': 'Quadratisch',
      'Diamond': 'Diamant',
      'Edit': 'Bearbeiten',
      'Comment': 'Kommentar',
      'Comment Panel': 'Kommentarbereich',
      'Set Status': 'Status setzen',
      'Post': 'Posten',
      'Page': 'Seite',
      'Add a comment': 'Kommentar hinzufügen',
      'Add a reply': 'Antwort hinzufügen',
      'Import Annotations': 'Anmerkungen importieren',
      'Export Annotations': 'Anmerkungen exportieren',
      'Add': 'Hinzufügen',
      'Clear': 'Löschen',
      'Bold': 'Fett',
      'Italic': 'Kursiv',
      'Strikethroughs': 'Durchstreichen',
      'Underlines': 'Unterstreichen',
      'Superscript': 'Hochgestellt',
      'Subscript': 'Tiefgestellt',
      'Align left': 'Linksbündig',
      'Align right': 'Rechtsbündig',
      'Center': 'Zentriert',
      'Justify': 'Blocksatz',
      'Font color': 'Schriftfarbe',
      'Text Align': 'Textausrichtung',
      'Text Properties': 'Texteigenschaften',
      'Draw Free Hand': 'Freihand zeichnen',
      'Draw Signature': 'Unterschrift zeichnen',
      'Signature': 'Unterschrift',
      'Draw Ink': 'Freihand',
      'Create': 'Erstellen',
      'Font family': 'Schriftfamilie',
      'Font size': 'Schriftgröße',
      'Free Text': 'Freier Text',
      'Import Failed': 'Import fehlgeschlagen',
      'Export Failed': 'Export fehlgeschlagen',
      'File not found': 'Datei nicht gefunden',
      'Insufficient permission': 'Unzureichende Berechtigung',
      'of': 'von',
      'Dynamic': 'Dynamisch',
      'Standard Business': 'Standard Geschäft',
      'Sign Here': 'Hier unterschreiben',
      'Custom Stamp': 'Eigener Stempel',
      'InitialStamp': 'Initialstempel',
      'HandWrittenSignature': 'Handschriftliche Unterschrift',
      'Image': 'Bild',
      'Type': 'Typ',
      'Upload': 'Hochladen',
      'Clear Selection': 'Auswahl löschen',
      'Bring To Front': 'In den Vordergrund',
      'Send To Back': 'In den Hintergrund',
      'Assign Formula': 'Formel zuweisen',
      'Add Textbox': 'Textfeld hinzufügen',
      'Add Password': 'Passwort hinzufügen',
      'Add Checkbox': 'Kontrollkästchen hinzufügen',
      'Add Radiobox': 'Optionsfeld hinzufügen',
      'Add Dropdown': 'Dropdown hinzufügen',
      'Add Listbox': 'Listenfeld hinzufügen',
      'Add Signature': 'Unterschrift hinzufügen',
      'Save': 'Speichern',
      'Organize Pages': 'Seiten organisieren',
      'Insert Right': 'Rechts einfügen',
      'Insert Left': 'Links einfügen',
      'Rotate Right': 'Rechts drehen',
      'Rotate Left': 'Links drehen',
      'Copy Pages': 'Seiten kopieren',
      'Delete Pages': 'Seiten löschen',
      'Total': 'Gesamt',
      'Select All': 'Alles auswählen',
      'Import Document': 'Dokument importieren'
    }
  }
};

// Funktion zum Initialisieren der deutschen Lokalisierung
export const initSyncfusionLocale = () => {
  // Deutsche Übersetzungen laden
  L10n.load(deLocale);

  // Kultur auf Deutsch setzen
  setCulture('de');
};

export default initSyncfusionLocale;
